import { createAsyncThunk } from "@reduxjs/toolkit";
import workspaceService from "../../../shared/services/api/workspace-service";
import { ICreateWorkspaceRequest, ISwitchWorkspaceRequest } from "../../../shared/services/interface/requests/IWorkspace";

export const getUserWorkspaces = createAsyncThunk(
  "workspace/getUserWorkspaces",
  async (_, thunkAPI) => {
    try {
      const response = await workspaceService.getUserWorkspaces();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Workspace'ler yüklenirken hata oluştu");
    }
  }
);

export const createWorkspace = createAsyncThunk(
  "workspace/createWorkspace",
  async (data: ICreateWorkspaceRequest, thunkAPI) => {
    try {
      const response = await workspaceService.createWorkspace(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Workspace oluşturulurken hata oluştu");
    }
  }
);

export const updateWorkspace = createAsyncThunk(
  "workspace/updateWorkspace",
  async ({ companyId, data }: { companyId: string; data: ICreateWorkspaceRequest }, thunkAPI) => {
    try {
      const response = await workspaceService.updateWorkspace(companyId, data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Workspace güncellenirken hata oluştu");
    }
  }
);

export const switchWorkspace = createAsyncThunk(
  "workspace/switchWorkspace",
  async (data: ISwitchWorkspaceRequest, thunkAPI) => {
    try {
      const response = await workspaceService.switchWorkspace(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        {
          success: false,
          data: error?.message || "Workspace değiştirilirken hata oluştu",
        }
      );
    }
  }
); 